module.exports = __webpack_public_path__ + "img/1564116482.f06c5b91.jpg";